module.exports = __webpack_public_path__ + "static/img/serverBg.7b625f56.png";